import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import './SpeakersFeatured.css';

import Speaker from './Speaker';

export default class SpeakersFeatured extends React.PureComponent {
    async componentDidMount() {
        // await this.props.fetchSpeakers();
        if (this.props.route === '/speakers') {
            window.scrollTo(0, 0);
        }
    }

    onSpeakerClick = speakerId => () => {
        this.props.pushAction(`/speakers/${speakerId}`);
    };

    onSpeakersButtonClick = () => {
        this.props.pushAction('/speakers');
    };

    render() {
        const { speakers } = this.props;
        const orderedSpeakers = orderBy(speakers, ['order'], ['desc']);
        const filteredSpeakers =
            this.props.route === '/speakers'
                ? orderedSpeakers
                : orderedSpeakers.filter(({ featured }) => featured === true);

        const header =
            this.props.route === '/speakers' ? (
                <div className="page-title">
                    <h1>SPEAKERS</h1>
                </div>
            ) : (
                <h1 className="section-title">SPEAKERS</h1>
            );

        const button =
            this.props.route !== '/speakers' ? (
                <button
                    className="button is-large  "
                    id="speakers-button"
                    onClick={this.onSpeakersButtonClick}
                    type="button"
                >
                    More Speakers
                </button>
            ) : null;

        return (
            <section
                className={`section ${this.props.route === '/speakers' ? 'speakers-section' : ''}`}
                id="speakers-featured"
            >
                <div className="container">
                    {header}
                    {this.props.fetchingSpeakers ? (
                        <i
                            className="fa fa-spinner fa-spin fa-3x fa-fw"
                            style={{ color: '#7500c0' }}
                        />
                    ) : (
                        <div className="columns is-variable is-mobile is-multiline">
                            {filteredSpeakers.map(({ id, img, name, company, shortDesc }) => (
                                <Speaker
                                    company={company}
                                    id={id}
                                    img={img}
                                    key={id}
                                    name={name}
                                    onSpeakerClick={this.onSpeakerClick}
                                    shortDesc={shortDesc}
                                />
                            ))}
                        </div>
                    )}
                    {button}
                </div>
            </section>
        );
    }
}

SpeakersFeatured.propTypes = {
    fetchingSpeakers: PropTypes.bool.isRequired,
    pushAction: PropTypes.func.isRequired,
    route: PropTypes.string.isRequired,
    speakers: PropTypes.arrayOf(
        PropTypes.shape({
            company: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            shortDesc: PropTypes.string.isRequired
        })
    ).isRequired
};
